import { Link } from "react-router-dom";
import { useContent } from "@/context/ContentContext";
import { LOGO_URL } from "@/data/homeContent";
import { MapPin } from "lucide-react";

export const Footer = () => {
  const content = useContent();
  return (
    <footer className="bg-[#2a0a12] text-slate-300" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        {/* Column 1: Logo + text */}
        <div data-testid="footer-col-brand">
          <img src={LOGO_URL} alt="BSD Boarding School Directory" className="h-10 w-auto bg-white rounded px-1 py-0.5" />
          <p className="mt-5 text-sm leading-relaxed text-slate-400">{content.footer_text}</p>
        </div>

        {/* Column 2 */}
        <div data-testid="footer-col-nav">
          <h4 className="font-serif text-xl text-white mb-4">Explore</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:text-[#C5A059] transition-colors" data-testid="footer-link-home">Home</Link></li>
            <li><Link to="/digital-edition" className="hover:text-[#C5A059] transition-colors" data-testid="footer-link-digital">Digital Edition</Link></li>
            <li><Link to="/list-your-school/listing-options" className="hover:text-[#C5A059] transition-colors" data-testid="footer-link-listing">Listing</Link></li>
            <li><Link to="/about" className="hover:text-[#C5A059] transition-colors" data-testid="footer-link-about">About Us</Link></li>
          </ul>
        </div>

        {/* Column 3 */}
        <div data-testid="footer-col-options">
          <h4 className="font-serif text-xl text-white mb-4">Listing Options</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/list-your-school/listing-options" className="hover:text-[#C5A059] transition-colors">Double Page</Link></li>
            <li><Link to="/list-your-school/listing-options" className="hover:text-[#C5A059] transition-colors">Full Page</Link></li>
            <li><Link to="/list-your-school/listing-options" className="hover:text-[#C5A059] transition-colors">Half Page</Link></li>
            <li><Link to="/list-your-school/listing-options" className="hover:text-[#C5A059] transition-colors">Normal Listing</Link></li>
          </ul>
        </div>

        {/* Column 4: Contact */}
        <div data-testid="footer-col-contact">
          <h4 className="font-serif text-xl text-white mb-4">Contact</h4>
          <div className="flex gap-3 text-sm text-slate-400">
            <MapPin className="h-5 w-5 shrink-0 text-[#C5A059] mt-0.5" />
            <address className="not-italic leading-relaxed">
              <span className="text-white font-medium">{content.contact_company}</span>
              <br />
              <span className="whitespace-pre-line">{content.contact_address}</span>
            </address>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 text-xs text-slate-500 flex flex-col sm:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} BSD Boarding School Directory. All rights reserved.</span>
          <span>Published by {content.contact_company}</span>
        </div>
      </div>
    </footer>
  );
};
